import { useCurrentUser } from '@qualio/ui-components';
import { useQuery } from 'react-query';
import templateApi from '../api/templateApi';

export const useDocumentTemplate = (
  templateId: number | undefined,
  enabled: boolean,
) => {
  const { companyId } = useCurrentUser();

  return useQuery({
    queryKey: ['documentTemplate', companyId, templateId],
    queryFn: () => templateApi.getTemplate(companyId, templateId!),
    enabled: enabled && !!templateId,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
